package com.xtream.composeapp.viewmodel


 import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.xtream.composeapp.data.Screen
import com.xtream.composeapp.theme.AppTheme
import com.xtream.data_kmp.PreferencesRepo
import com.xtream.data_kmp.PreferencesRepo.Companion.ALWAYS_USE_HTTPS_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.APP_THEME_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.FORCE_PLAYER_REFRESH_ON_UPDATE_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.LANGUAGE_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.LAST_DATA_UPDATE_MILlIS_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.LAST_PLAYED_ACTIVITY_ENABLED_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.LAST_PLAYED_CATEGORY_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.LAST_PLAYED_SCREEN_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.LAST_PLAYED_STREAM_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.LAST_VISITED_SCREEN_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.LIVE_STREAM_FORMAT_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.PLAYLIST_REFRESH_INTERVAL_KEY
 import com.xtream.data_kmp.PreferencesRepo.Companion.SKIP_ACCOUNT_REFRESH
 import com.xtream.data_kmp.PreferencesRepo.Companion.VIDEO_RENDER_MODE_KEY
import com.xtream.data_kmp.PreferencesRepo.Companion.VIDEO_SCALING_MODE_KEY
import com.xtream.data_kmp.dto.Account
import com.xtream.data_kmp.util.extension.decodeFromStringOrNull
import com.xtream.data_kmp.util.extension.formatAsDateTime
import com.xtream.data_kmp.util.extension.safeEncodeToString
import io.ktor.http.URLBuilder
import io.ktor.http.Url
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.distinctUntilChanged
import kotlinx.coroutines.flow.first
import kotlinx.coroutines.flow.map
import kotlinx.serialization.json.Json
import kotlinx.serialization.modules.SerializersModule
import kotlinx.serialization.modules.polymorphic
import kotlin.time.Clock
import kotlin.time.Duration.Companion.days


enum class VideoScalingMode {
    Fit,
    Fill,
    Crop,
    FillWidth,
    FillHeight
}

open class AppSettingsViewModel (
    private  val appSettingsRepo: PreferencesRepo
):ViewModel() {



    /**
     * Resume last played activity enabled, default value is true
     */
    val resumeLastPlayedActivityEnabledFlow= appSettingsRepo.readFromDataStore.map { it.resumeLastActivityEnabled }

    /***
     * Last updated data millis, default value is 0
     */
    val lastUpdatedDataMillisFlow= appSettingsRepo.readFromDataStore.map { it.lastUpdatedDataMillis?:0 }
    val lastUpdatedDataDate= lastUpdatedDataMillisFlow.map { refreshDate->refreshDate.formatAsDateTime() }

    val lastPlayedScreenFlow = appSettingsRepo.readFromDataStore.map { it.lastPlayedScreen }
    val lastPlayedCategoryFlow = appSettingsRepo.readFromDataStore.map {
        return@map it.lastPlayedCategory
    }
    val lastPlayedStream = appSettingsRepo.readFromDataStore.map {
        return@map it.lastPlayedStream
    }
    val languageFlow= appSettingsRepo.readFromDataStore.map { it.language?: "en" }

    /**
     * A Flow emitting the current application theme preference.
     *
     * This flow is derived from DataStore and updates whenever the user changes
     * their theme setting.
     *
     * Default: [AppTheme.SYSTEM]
     */

    val appThemeFlow= appSettingsRepo.readFromDataStore.map { AppTheme.valueOf(it.theme?:AppTheme.DARK.name) }


    val  forcePlayerRefreshOnUpdateFlow= appSettingsRepo.readFromDataStore.map { it.forcePlayerRefreshOnUpdate }
    val  alwaysUseHttpsFlow= appSettingsRepo.readFromDataStore.map { it.alwaysUseHTTPS }
    val  liveStreamFormatFlow= appSettingsRepo.readFromDataStore.map { it.liveStreamFormat?:".ts" } .distinctUntilChanged()

    val videoScalingModeFlow= appSettingsRepo.readFromDataStore.map { it.videoScalingMode?:0/*TODO AspectRatioFrameLayout.RESIZE_MODE_FILL*/ }



    val videoRenderModeFlow= appSettingsRepo.readFromDataStore.map {

        it.videoRenderMode?:0
       /* TODO _root_ide_package_.androidx.media3.ui.compose.SURFACE_TYPE_TEXTURE_VIEW*/
    }
    val playlistRefreshIntervalFlow= appSettingsRepo.readFromDataStore.map { it.playlistRefreshInterval?:"1" }

    private val _isPortrait = MutableStateFlow(false)
/*
    val contentScaleFlow: Flow<ContentScale> =
        videoScalingModeFlow.combine(_isPortrait) { scalingMode, isPortrait ->
            if (isPortrait) {
                ContentScale.Fit
            } else {
                when (scalingMode) {
                    VideoScalingMode.Fit -> ContentScale.Fit
                    VideoScalingMode.Fill -> ContentScale.FillBounds
                    VideoScalingMode.Crop -> ContentScale.Crop
                    VideoScalingMode.FillWidth -> ContentScale.FillWidth
                    VideoScalingMode.FillHeight -> ContentScale.FillHeight
                    else-> ContentScale.Fit
                }
            }
        }*/
    fun updateOrientation(isPortrait: Boolean) {
        _isPortrait.value = isPortrait
    }

    fun setIsAlwaysUseHTTPS(enabled:Boolean) = appSettingsRepo.editPref(viewModelScope,ALWAYS_USE_HTTPS_KEY, enabled)

    fun setResumeLastPlayedActivityEnabled(enabled:Boolean) = appSettingsRepo.editPref(viewModelScope,LAST_PLAYED_ACTIVITY_ENABLED_KEY, enabled)
    fun setLastUpdatedDataMillis(millis:Long?, onDone: () -> Unit={}) = appSettingsRepo.editPref(viewModelScope, LAST_DATA_UPDATE_MILlIS_KEY, millis, true, onDone)
    fun setSkipAccountRefresh(skip: Boolean?, onDone: () -> Unit={}) = appSettingsRepo.editPref(viewModelScope, SKIP_ACCOUNT_REFRESH, skip, false, onDone)
    val screenJson get() =  Json {
        serializersModule = SerializersModule {
            polymorphic(Screen::class) {
                subclass(Screen.LiveStreamPlayer::class, Screen.LiveStreamPlayer.serializer())
                subclass(Screen.VideoPlayer::class, Screen.VideoPlayer.serializer())
                subclass(Screen.TvShowVideoPlayer::class, Screen.TvShowVideoPlayer.serializer())
            }
        }
        classDiscriminator = "type" // default is "type"
        ignoreUnknownKeys = true
    }
    fun setLastVisitedScreen( screen:Screen?){


        val screenJsonString = screenJson.safeEncodeToString(screen)
        //Log.d("visitedScreen", "setLastVisitedScreen: ${screenJsonString}")
        //setLastVisitedScreen: {"type":"com.myxtream.tv.presentation.ui.touchscreen.navbar.Screen.LiveStreamPlayer","id":4097,"streamId":4097,"categoryId":41,"title":"SAT7 KIDS"}
        appSettingsRepo.editPref(viewModelScope, LAST_VISITED_SCREEN_KEY, screenJsonString,clearPrefIfNull = true)
    }

    @Deprecated( "use setLastVisitedScreen()", ReplaceWith("setLastVisitedScreen(screen)"))
    fun setLastPlayedScreen( screen:String?)= appSettingsRepo.editPref(viewModelScope, LAST_PLAYED_SCREEN_KEY, screen,clearPrefIfNull = true)

    fun setLastPlayedCategory(category: String?)= appSettingsRepo.editPref(viewModelScope, LAST_PLAYED_CATEGORY_KEY, category,clearPrefIfNull = true)
    fun setLastPlayedStream( stream: String?)= appSettingsRepo.editPref(viewModelScope, LAST_PLAYED_STREAM_KEY, stream,clearPrefIfNull = true)
    fun setForcePlayerRefreshOnUpdate(enabled:Boolean) = appSettingsRepo.editPref(viewModelScope,FORCE_PLAYER_REFRESH_ON_UPDATE_KEY, enabled)
    fun setLiveStreamFormat(format:String) = appSettingsRepo.editPref(viewModelScope, LIVE_STREAM_FORMAT_KEY, format)
    fun setVideoScalingMode( mode:Int?)= appSettingsRepo.editPref(viewModelScope, VIDEO_SCALING_MODE_KEY, mode)
    fun setVideoRenderMode( mode:Int?)= appSettingsRepo.editPref(viewModelScope, VIDEO_RENDER_MODE_KEY, mode)
    fun setLanguage(language:String?, onDone: () -> Unit)= appSettingsRepo.editPref(viewModelScope, LANGUAGE_KEY, language, onDone = onDone )
    fun setAppTheme(theme:String?)= appSettingsRepo.editPref(viewModelScope, APP_THEME_KEY, theme,  )
    fun setPlaylistRefreshInterval( interval:String?)=   appSettingsRepo.editPref(viewModelScope, PLAYLIST_REFRESH_INTERVAL_KEY, interval)





    suspend fun  lastVisitedScreen() = appSettingsRepo.readFromDataStore.map {
        it.lastVisitedScreen

    }.first()
    suspend fun isSkipAccountRefresh() = appSettingsRepo.readFromDataStore.map {
        it.skipAccountRefresh

    }.first()
    @Deprecated( "use lastVisitedScreen()", ReplaceWith("lastVisitedScreen()"))
    suspend fun  lastPlayedScreen() = appSettingsRepo.readFromDataStore.map {
        it.lastPlayedScreen
    }.first()
    suspend fun lastPlayedCategory() = appSettingsRepo.readFromDataStore.map { it.lastPlayedCategory}.first()
    suspend fun lastPlayedStream(): String? = appSettingsRepo.readFromDataStore.map {it.lastPlayedStream}.first()







    suspend fun needRefreshData(): Boolean {
        //get
        val refreshInterval = playlistRefreshIntervalFlow.first()
       // Log.d("DataLoader", "needRefreshData: $refreshInterval")
        if (refreshInterval == "0") return true
        val refreshIntervalInt = refreshInterval.toLongOrNull() ?: 0
        val intervalMillis = refreshIntervalInt.days.inWholeMilliseconds//86400000


        val lastRefreshMillis = lastUpdatedDataMillisFlow.first()//1723922614000

        val diff = Clock.System.now().toEpochMilliseconds() - lastRefreshMillis
        //1724007414000 - 1723922614000 = 74800000

        return diff >= intervalMillis
    }


    suspend fun cachedActivationServer() = appSettingsRepo.readFromDataStore.first().activationServerUrl
    suspend fun cachedUserServer() = appSettingsRepo.readFromDataStore.first().accountServerUrl

    suspend fun hasCachedActivationServer(): Boolean {
        return appSettingsRepo.readFromDataStore.first().activationServerUrl!=null
    }
    suspend fun hasCachedUserServer(): Boolean {
        return appSettingsRepo.readFromDataStore.first().accountServerUrl!=null
    }




    suspend fun defaultRoute(account: Account?): List<Screen>{
        val resumeLastScreen: Boolean = resumeLastPlayedActivityEnabledFlow.first()


        val stack=  mutableListOf<Screen>( Screen.NavBar)
        val lastScreenJson= lastVisitedScreen()
        val lastScreen = screenJson.decodeFromStringOrNull<Screen>( lastScreenJson)
       // Log.d("lastScreen", "defaultRoute: $lastScreen")
        val currentPass = account?.userInfo?.password

        if (resumeLastScreen && lastScreen!=null){
            when (lastScreen ){
                is Screen.VideoPlayer, -> lastScreen.copy( url = updatePassSegment(lastScreen.url, currentPass))
                is Screen.TvShowVideoPlayer-> lastScreen.copy( url = updatePassSegment(lastScreen.url, currentPass))
                else -> lastScreen
            }.let {
                stack.add(it)
            }
        }
        return stack
    }



    private fun updatePassSegment(originalUrl: String?, newPass: String?): String =
        runCatching {
            val url = Url(originalUrl ?: return "")
            val seg = url.segments.toMutableList()
            if (seg.size >= 3 && newPass != null) seg[2] = newPass
            URLBuilder(url).apply { encodedPathSegments = seg }.buildString()
        }.getOrDefault("")
}
